import curd from '../curd'

const BASE_PATH = '/audit/rule'

export default curd(BASE_PATH, {
  getUsedFactors: auditRuleTypeId => ({
    url: `${BASE_PATH}/selected/factor/${auditRuleTypeId}`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/AutoAuditRule.js